<template>
    <div class="table">
        <div class="crumbs">
            <el-breadcrumb separator="/">
                <el-breadcrumb-item>{{menuName}}</el-breadcrumb-item>
            </el-breadcrumb>
        </div>
        
        <!--卡号管理-->
        <div class="container">
            <div style="display: inline-block; height:40px;">
                <div style="width:160px;">
                    <el-select v-model="deptId" placeholder="请选择学校">
                        <el-option
                            v-for="item in depts"
                            :key="item.id"
                            :label="item.name"
                            :value="item.id">
                        </el-option>
                    </el-select>
                </div>
            </div>
            <div style="display: inline-block; height:40px;">
                <div style="width:160px;">
                    <el-input v-model="cardNo" placeholder="卡号" clearable></el-input>
                </div>
            </div>
            <div style="display: inline-block; height:40px;">
                <div style="width:160px;">
                    <el-input v-model="studentName" placeholder="学生姓名" clearable></el-input>
                </div>
            </div>
            <el-button type="primary" icon="search" @click="common.page = 1;getData()">查询</el-button>

            <div style="display: block; height:40px;float:right;">
                <el-button type="primary" class="handle-del mr10" icon="el-icon-plus" @click="setAdd()">新增</el-button>
                <el-button type="primary" class="handle-del mr10" icon="el-icon-folder-add" @click="importCard()">导入</el-button>
                <el-button type="primary" @click="exportExcel">导出</el-button>
            </div>

            <el-table
                :data="data"
                style="width:100%;margin-bottom:20px;"
                row-key="id"
                height="550"
                border
                v-loading="loading"
                :element-loading-text="loadingText"
                element-loading-spinner="el-icon-loading"
                element-loading-background="rgba(255, 255,255,0.7)"
                default-expand-all>
                <el-table-column type="index" fixed label="序号" width="55px" :index="indexMethod"> </el-table-column>
                <el-table-column prop="cardNo" label="卡号" min-width="140" :show-overflow-tooltip="true"></el-table-column>
                <el-table-column prop="studentName" label="学生姓名" min-width="120" :show-overflow-tooltip="true">
                    <template slot-scope="scope">
                        <span v-if="scope.row.studentName != null && scope.row.studentName !== ''">{{scope.row.studentName}}</span>
                        <span v-else style="color:#909399;">未绑定</span>
                    </template>
                </el-table-column>
                <!-- <el-table-column prop="className" label="班级名称" min-width="140" :show-overflow-tooltip="true"></el-table-column> -->
                <el-table-column prop="useFlag" label="是否使用" width="100">
                    <template slot-scope="scope">
                        <span v-if="scope.row.useFlag == 1" style="color: #387EE8;">已使用</span>
                        <span v-else-if="scope.row.useFlag == 0" style="color: #909399;">未使用</span>
                        <span v-else>-</span>
                    </template>
                </el-table-column>
                <el-table-column prop="status" label="状态" width="100">
                    <template slot-scope="scope">
                        <span v-if="scope.row.status == 1" style="color: #67C23A;">启用</span>
                        <span v-else-if="scope.row.status == 2" style="color: #F56C6C;">禁用</span>
                        <span v-else>-</span>
                    </template>
                </el-table-column>
                <el-table-column fixed="right" label="操作" width="100px">
                    <template slot-scope="scope">
                        <el-button
                            @click.native.prevent="setUpdate(scope.row)"
                            type="text"
                            size="small"
                            style="color: #387EE8;">
                            修改
                        </el-button>
                        <el-button
                            @click.native.prevent="del(scope.row)"
                            type="text"
                            size="small"
                            style="color: #F56C6C;">
                            删除
                        </el-button>
                    </template>
                </el-table-column>
            </el-table>

            <div class="pagination">
                <el-pagination
                    @size-change="handleSizeChange"
                    @current-change="handleCurrentChange"
                    :current-page="common.page"
                    :page-size="common.pageSize"
                    :page-sizes="common.allSizes"
                    layout="total,sizes, prev, pager, next, jumper"
                    :total="common.total">
                </el-pagination>
            </div>

            <div v-if="addVisible">
                <add ref="add"></add>
            </div>
            <div v-if="updateVisible">
                <update ref="update"></update>
            </div>
            <div v-if="importVisible">
                <importCard ref="importCard"></importCard>
            </div>
        </div>
    </div>
</template>

<script>
    import axios from 'axios';
    import http from '../../../../common/http';
    import add from './Add.vue';
    import update from './Update.vue';
    import importCard from './Import.vue';

    export default {
        name:"CardManage",
        data(){
            return{
                loading:false,
                loadingText:"",
                menuName:"",
                data:[],
                depts:[],
                deptId: "",
                cardNo:"",
                studentName:"",
                addVisible:false,
                updateVisible:false,
                importVisible:false,
                editId:"",
                common:{
                    total:0,
                    pageSize:30,
                    page:1,
                    isPage:1,
                    allSizes:[30,50,100],
                }
            }
        },
        components: { add, update, importCard },
        created:function () {
            this.menuName = sessionStorage.getItem("selectMenuItem_key");
            this.getDeptData();
        },
        methods:{
            indexMethod(index) {
                return (this.common.page-1)*this.common.pageSize+(index+1);
            },
            getDeptData(){
                let url  = this.listDeptUrl;
                let data = {parentId:"0"};
                this.apiPost(url,data).then((res) => {
                    if(res.status==200){
                        this.depts=res.data.list;
                        if(this.depts.length>0){
                           this.deptId=this.depts[0].id;
                        }
                        this.getData();
                    }else{
                        this.$commonFn.showTip(res.message,3);
                    }
                },(err)=>{
                    console.log(err);
                });
            },
            getData(){
                this.loading=true;
                this.loadingText="数据加载中...";

                let url  = this.cardManageUrl;
                let data = {
                    isPage:this.common.isPage,
                    page:this.common.page,
                    limit:this.common.pageSize,
                    deptId:this.deptId,
                    cardNo:this.cardNo,
                    studentName:this.studentName
                };
                
                this.apiPost(url,data).then((res) => {
                    if(res.status==200){
                        this.data = res.data.list || res.data.data || [];
                        this.common.total = res.data.total || 0;
                    }else{
                        this.$commonFn.showTip(res.message,3);
                    }
                    this.loading=false;
                },(err)=>{
                    console.log(err);
                    this.loading=false;
                });
            },
            handleSizeChange(val) {
                this.common.pageSize = val;
                this.common.page = 1;
                this.getData();
            },
            handleCurrentChange(val) {
                this.common.page = val;
                this.getData();
            },
            setAdd(){
                this.addVisible=true;
                this.$nextTick(() => {
                    this.$refs['add'].init(this.deptId);
                })
            },
            setUpdate(row){
                this.updateVisible=true;
                this.$nextTick(() => {
                    this.$refs['update'].init(row, this.deptId);
                })
            },
            importCard(){
                this.importVisible=true;
                this.$nextTick(() => {
                    this.$refs['importCard'].init(this.deptId);
                })
            },
            del(row){
                this.editId = row.id;
                this.$commonFn.showConfirm(this.delSuccess);
            },
            delSuccess(){
                this.loading=true;
                this.loadingText="正在删除中...";

                let url = this.cardRemoveUrl;
                let data = { id:this.editId };
                this.apiPost(url,data).then((res)=>{
                    this.loading=false;
                    if(res.status == 200){
                        this.$commonFn.showTip(res.message,1);
                        this.common.page = 1;
                        this.getData();
                    }else{
                        this.$commonFn.showTip(res.message,3);
                    }
                },(err)=>{
                    console.log(err);
                    this.loading=false;
                })
            },
            exportExcel(){
                this.loading=true;
                this.loadingText="正在导出中，导出过程时间可能会比较长，请耐心等待";

                let url=this.cardExportUrl;
                let param = new URLSearchParams();
                param.append('deptId', this.deptId);
                param.append('cardNo', this.cardNo);
                param.append('studentName', this.studentName);
                
                axios({
                    method: "post",
                    url: url,
                    data: param,
                    responseType: "blob"
                }).then(res => {
                    const link = document.createElement("a");
                    let blob = new Blob([res.data], { type: "application/vnd.ms-excel" });
                    link.style.display = "none";
                    link.href = URL.createObjectURL(blob);
                    link.setAttribute("download", '卡号管理.xls');
                    document.body.appendChild(link);
                    link.click();
                    document.body.removeChild(link);
                    this.loading=false;
                }).catch(error => {
                    console.log(error); 
                    this.loading=false;
                });
           },
        },
        mixins: [http]
    }
</script>

<style scoped>
</style>




// WEBPACK FOOTER //
// src/components/page/sys/card/Card.vue